<template>
    <div class="overlay-spinner-loading">
        <img :src="require('../../assets/img/logo_sportips_black.png')" alt="" class="rounded" />
        <v-progress-circular
        :size="50"
      color="primary"
      indeterminate
    ></v-progress-circular>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss">
    .overlay-spinner-loading {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.8);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        z-index: 9999;
        gap:20px;
        img{
            width:80px;
            height:auto;
        }
    }

</style>